import CreateEventRegistrationInvite from "./CreateEventRegistrationInvite";

export default CreateEventRegistrationInvite;
